// extracted by mini-css-extract-plugin
module.exports = {"main":"SingleColumnLayout_main__bHelm","map":"SingleColumnLayout_map__PXonX","content":"SingleColumnLayout_content___DR58"};